import {
  Component,
  OnInit,
  ViewChild,
  NgZone,
  AfterViewInit,
  ElementRef,
  OnDestroy
} from "@angular/core";
import { SlicePipe } from "@angular/common";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { Subject ,  Observable } from "rxjs";
import { HttpClientModule } from "@angular/common/http";
import { DataTableDirective } from "angular-datatables";
import {
  NgbModal,
  ModalDismissReasons,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { logbaseService } from "../../services/logbase.service";
import { DatePipe } from "@angular/common";
import { Router, ActivatedRoute } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { TranslateService } from "@ngx-translate/core";
import { dateFormatPipe } from "../../pipes/dateFormatPipe";
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
//import { debug } from "util";
import { NgbPanelChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { MatTableDataSource } from "@angular/material/table";
import { CalendarModule } from "primeng/calendar";
import {MatExpansionModule, MatExpansionPanel} from '@angular/material/expansion';

export interface NewPartsData{
partNumber:any;
supplierCode:any;
partName:any;
deliveryPoint:any;
lineNumber:any;
assignedDate:any;
dueDate:any;
historyImg:any;
history:any;
partNo:any;
ovarAllPackageIDStatus:any;
}

export interface InprogressData
{
 partNumber:any;
 supplierCode:any;
 partName:any;
 deliveryPoint:any;
 lineNumber:any;
 supplierStatus:any;
 supplierManagerStatus:any;
 supplierManagerVSStatus:any;
 logisticStatus:any;
 operatorStatus:any;
 ovarAllPackageIDStatus:any;
 historyImg:any;
 history:any;
 partNo:any;

 

}

export interface UnderReviewData
{
  partNumber:any;
  supplierCode:any;
  partName:any;
  deliveryPoint:any;
  lineNumber:any;
  supplierStatus:any;
  supplierManagerStatus:any;
  supplierManagerVSStatus:any;
  logisticStatus:any;
  operatorStatus:any;
  ovarAllPackageIDStatus:any;
  historyImg:any;
  history:any;
  partNo:any;

}
export interface ApprovedData
{
  partNumber:any;
  supplierCode:any;
  partName:any;
  deliveryPoint:any;
  lineNumber:any;
  supplierStatus:any;
  supplierManagerStatus:any;
  supplierManagerVSStatus:any;
  logisticStatus:any;
  operatorStatus:any;
  ovarAllPackageIDStatus:any;
  historyImg:any;
  history:any;
  partNo:any;
}

export interface RejectedData{
  partNumber:any;
  supplierCode:any;
  partName:any;
  deliveryPoint:any;
  lineNumber:any;
  supplierStatus:any;
  supplierManagerStatus:any;
  supplierManagerVSStatus:any;
  logisticStatus:any;
  operatorStatus:any;
  historyImg:any;
}

export class partStatus {
  partNo: number;
  packageID: string;
  partName: string;
  assignedDate: string;
  lastUpdate: string;
  dueDate: string;
  history: string;
}

const OPERATION_TYPE = "Supplier To Supplier";

@Component({
  selector: "app-part-status",
  templateUrl: "./part-status.component.html",
  styleUrls: ["./part-status.component.scss"]
})
export class PartStatusComponent implements OnInit,OnDestroy {
  enableExport: boolean;
  exportlength: any;
  appCycle: any = 0;
  searchString: any;
  psconfig: any;
  searchAppParts: any;
  smTTAppMsg: any;
  supTTAppMsg: any;
  supTTRejMsg: any;
  sMTTAppMsg: any;
  tooltipRejMsg: any;
  tooltipAppMsg: any;
  tooltipMsg: any;
  filterSuppCode: any = [];
  filterlineNos: any = [];
  lineNoFilter: any;
  opmDeliveryPointFilter: any;
  opmDSupplierCodeFilter: any;
  rejlength: any;
  applength: any;
  iplength: any;
  nplength: any;
  urlength: any;
  rejResponse: any;
  latest_rejected_Data: any[];
  latest_approved_Data: any[];
  approved_row: any[];
  appResponse: any;
  latest_underReview_Data: any[];
  underReview_row: any;
  urResponse: any;
  ipResponse: any;
  latest_rej_Data: any[];
  rejPartsData: any[];
  lineNos: any;
  userSuppCode: any;
  userRoleId: any;
  userDetJson: any;
  userDetails: string;
  userOperationType: string;
  rejected_row: any;
  latest_inProgress_Data: any[];
  inProgress_row: any;
  latest_NewPart_Data: any[];
  newPart_row: any;
  parts: any;
  newPartsData: any[];
  userDetialsTableTitle: string;
  deliveryPointSelectionArray = [];
  supplierCodeSelectionArray: any = [];
  checkOperationType: boolean = false;

  opsupplierCode: any[];
  opDeliveryPoint: any[];

  //Accordion active IDs
  activeIds: string[] = ["static-1"];

  newparts = [
    'partNumber',
   'supplierCode' ,
    'partName' ,
     'deliveryPoint' ,
     'lineNumber',
     'assignedDate' ,
     'dueDate' ,
    'historyImg' 
  ];
  newparts_data: MatTableDataSource<NewPartsData[]>;
  inprogress = [ 'partNumber' ,
 'supplierCode' ,
  'partName' ,
    'deliveryPoint' ,
   'lineNumber' ,
   'supplierStatus' ,
    'supplierManagerStatus' ,
  'supplierManagerVSStatus' ,
   'logisticStatus' ,
   'operatorStatus' ,
    'historyImg' ];
  inprogress_data: MatTableDataSource<InprogressData[]>;
  underReview = [ 'partNumber' ,
  'supplierCode' ,
  'partName' ,
 'deliveryPoint' ,
   'lineNumber' ,
   'supplierStatus' ,
    'supplierManagerStatus' ,
    'supplierManagerVSStatus' ,
    'logisticStatus' ,
   'operatorStatus' ,
'historyImg' ];
  underReview_data: MatTableDataSource<UnderReviewData[]>;
  approved=['partNumber' ,
  'supplierCode' ,
 'partName' ,
  'deliveryPoint' ,
 'lineNumber' ,
   'supplierStatus' ,
  'supplierManagerStatus' ,
  'supplierManagerVSStatus' ,
   'logisticStatus' ,
   'operatorStatus' ,
 'historyImg' ];
  approved_data: MatTableDataSource<ApprovedData[]>;
  rejected=[ 'partNumber' ,
    'supplierCode' ,
   'partName' ,
   'deliveryPoint' ,
  'lineNumber' ,
   'supplierStatus' ,
    'supplierManagerStatus' ,
   'supplierManagerVSStatus' ,
    'logisticStatus' ,
 'operatorStatus' ,
   'historyImg' ];
  rejected_data: MatTableDataSource<RejectedData[]>;

  //ng2-table intialization starts

  public rows: Array<any> = [];
  public InprogressaccrodianOpen = [false, false, false, false];
  public newPart_col: Array<any> = [
    { title: "Part No", name: "partNumber" },
    { title: "Supplier Code", name: "supplierCode" },
    { title: "Part Name", name: "partName" },
    { title: "Delivery Point", name: "deliveryPoint" },
    { title: "Next Process", name: "lineNumber" },
    { title: "Assigned Date", name: "assignedDate" },
    { title: "Due Date", name: "dueDate" },
    { title: "History", name: "historyImg" }
  ];

  public inProgress_col: Array<any> = [
    { title: "Part No", name: "partNumber" },
    { title: "Supplier Code", name: "supplierCode" },
    { title: "Part Name", name: "partName" },
    { title: "Delivery Point", name: "deliveryPoint" },
    { title: "Next Process", name: "lineNumber" },
    { title: "Supplier", name: "supplierStatus" },
    { title: "SM-Q", name: "supplierManagerStatus" },
    { title: "SM-VS", name: "supplierManagerVSStatus" },
    { title: "Logistics", name: "logisticStatus" },
    { title: "Operations", name: "operatorStatus" },
    { title: "History", name: "historyImg" }
  ];

  public underReview_col: Array<any> = [
    { title: "Part No", name: "partNumber" },
    { title: "Supplier Code", name: "supplierCode" },
    { title: "Part Name", name: "partName" },
    { title: "Delivery Point", name: "deliveryPoint" },
    { title: "Next Process", name: "lineNumber" },
    { title: "Supplier", name: "supplierStatus" },
    { title: "SM-Q", name: "supplierManagerStatus" },
    { title: "SM-VS", name: "supplierManagerVSStatus" },
    { title: "Logistics", name: "logisticStatus" },
    { title: "Operations", name: "operatorStatus" },
    { title: "History", name: "historyImg" }
  ];

  public approved_col: Array<any> = [
    { title: "Part No", name: "partNumber" },
    { title: "Supplier Code", name: "supplierCode" },
    { title: "Part Name", name: "partName" },
    { title: "Delivery Point", name: "deliveryPoint" },
    { title: "Next Process", name: "lineNumber" },
    { title: "Supplier", name: "supplierStatus" },
    { title: "SM-Q", name: "supplierManagerStatus" },
    { title: "SM-VS", name: "supplierManagerVSStatus" },
    { title: "Logistics", name: "logisticStatus" },
    { title: "Operations", name: "operatorStatus" },
    { title: "History", name: "historyImg" }
  ];

  public rejected_col: Array<any> = [
    { title: "Part No", name: "partNumber" },
    { title: "Supplier Code", name: "supplierCode" },
    { title: "Part Name", name: "partName" },
    { title: "Delivery Point", name: "deliveryPoint" },
    { title: "Next Process", name: "lineNumber" },
    { title: "Supplier", name: "supplierStatus" },
    { title: "SM-Q", name: "supplierManagerStatus" },
    { title: "SM-VS", name: "supplierManagerVSStatus" },
    { title: "Logistics", name: "logisticStatus" },
    { title: "Operations", name: "operatorStatus" },
    { title: "History", name: "historyImg" }
  ];

  public page: number = 1;
  public itemsPerPage: number = 10;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;

  public newPartconfig: any = {
    paging: true,
    sorting: { columns: this.newPart_col },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered"]
  };

  public inProgressconfig: any = {
    paging: true,
    sorting: { columns: this.inProgress_col },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered"]
  };

  public underReviewconfig: any = {
    paging: true,
    sorting: { columns: this.underReview_col },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered"]
  };

  public approvedconfig: any = {
    paging: true,
    sorting: { columns: this.approved_col },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered"]
  };

  public rejectedconfig: any = {
    paging: true,
    sorting: { columns: this.rejected_col },
    filtering: { filterString: "" },
    className: ["table-striped", "table-bordered"]
  };

  private data: Array<any> = [];

  //ng2-table intialization ends

  lineNumbers: any;
  lineNoList: any = [];
  opmSupplierCodeDropdownData: any = [];
  opmDeliveryPointDropdownData: any = [];
  opmScDpShow: boolean = false;
  suppC: any = [];
  rejClosedData: any;
  appClosedData: any;
  rejectedData: any;
  approvedData: any;
  underReviewData: any;
  inProgressData: any;
  newPartData: any;
  rejClosedCopy: any;
  appClosedCopy: any;
  rejectedCopy: any;
  approvedCopy: any;
  underReviewCopy: any;
  inProgressCopy: any;
  filterRejClosed: any = [];
  filterAppClosed: any = [];
  filterRejected: any = [];
  filterApproved: any = [];
  filterUnderReview: any = [];
  filterInProgress: any = [];
  newPartsCopy: any;
  filterNewParts: any = [];
  dropdownSettings: any;
  dropdownSettings2: any;
  dropdownSettings3: any;
  dropdownSettings4: any;

  delPoint: any;
  supPoint: any='';
  delPointList: any[] = [];
  suppCodeList: any[] = [];
  historyDetails: any;
  partStatusListFilter: any;
  suppCode: any;
  suppCodeVal: any;
  underReviewList: any;
  newParts: any;
  rejClosedList: any;
  appClosedList: any;
  rejectedList: any;
  approvedList: any;
  newPartsList: any;
  inProgressList: any;
  partStatusList: any;
  userRoleID: any;
  openTable: boolean = false;

  partStatus: any;
  UserUnderReviewDetails: any;
  // We use this trigger because fetching the list of persons can be quite long,
  // thus we ensure the data is fetched before rendering
  sortingItem = "updatedDate";
  ascending = false;
  modalRef: NgbModalRef;
  supplierCodes: any;
  allsuppCode: any[];
  disableSuppCodeSearch: boolean = true;
  disableNextProcessSearch: boolean = true;
  disableOMSupplierCodeSearch: boolean = true;
  disableOMDeliveryPointSearch: boolean = true;
  ovarAllAction: boolean = true;
  openedModal: any;
  srchValue_new:any;
  searchValue_inprogress;
  searchValue_under;
  searchValue_approved;
  searchValue_rejected;

  constructor(
    private elementref: ElementRef,
    private http: HttpClient,
    private modalService: NgbModal,
    private logbaseService: logbaseService,
    private router: Router,
    private spinner: NgxSpinnerService,
    private translate: TranslateService
  ) {
    this.userDetails = localStorage.getItem("userDetails");
    this.userDetJson = JSON.parse(this.userDetails);
    this.userRoleId = this.userDetJson.userRoleMappings[0].roleId;
    this.userSuppCode = this.userDetJson.supplierCode;
    let deliveryPointofUser = [];
    deliveryPointofUser = this.userDetJson.operationManagerdeliveryPointMaster;
    if (deliveryPointofUser == null || deliveryPointofUser.length == 0)
      this.lineNos = this.userDetJson.lineNumbers;
  }
  ngOnDestroy(): void {
    this.elementref.nativeElement.remove();
  }

  ngOnInit(): void {
    console.log("user",this.userRoleID)
    // this.spinner.show();

    // // Initialize pagination table
    // this.initPagingtable();

    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.userOperationType = userDetJson.operationType;
    this.lineNumbers = userDetJson.lineNumbers;
    this.checkOperationType =
      this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE
        ? true
        : false;
    // console.log("NG ON INIT",this.userRoleID, this.userOperationType)
    this.opsupplierCode = this.userDetJson.operationManagerSupplierCode;
    this.opDeliveryPoint = this.userDetJson.operationManagerdeliveryPointMaster;

    this.getOPMSupplierCodes();

    this.getDeliveryPoint();
    if (this.opmDeliveryPointDropdownData.length > 0) this.opmScDpShow = true;

    if (userDetJson.supplierCode) {
      this.suppCodeVal = userDetJson.supplierCode.toString();

      let suppCodeListArr = [];

      // To show supplier codes in supplier dropdown list for SM, log
      this.suppCodeList = this.suppCodeVal.split(",");
      console.log("supplier code list",this.suppCodeList)
      this.suppCodeList.forEach(function (value, key) {
        suppCodeListArr.push({ id: key + 1, itemName: value });
      });
      this.suppCodeList = suppCodeListArr;
      let selectedSuppCode = JSON.parse(
        localStorage.getItem("partStatusSuppCode")
      );
      this.supPoint = selectedSuppCode;
      this.initPagingtable()
      // Display all supplier code for logistic admin
      if (
        this.suppCodeList[0].itemName == "ALL" ||
        this.suppCodeList[0].itemName == "null" ||
        this.suppCodeList[0].itemName == ""
      ) {
        //Get all supplier codes starts

        if (this.userRoleID != 4) {
          this.logbaseService.getSupplierMasterData().subscribe(result => {
            this.supplierCodes = result.response;
            let suppCodeListArr = [];
            this.supplierCodes.forEach(function (value, key) {
              suppCodeListArr.push({
                id: key + 1,
                itemName: value.supplierCode
              });
            });
            this.allsuppCode = suppCodeListArr;
            this.suppCodeList = this.allsuppCode;
          });
        }
        //Get all supplier codes ends
      }
    }

    // Get delivery points only if it is operation login to display the delivery point for filtering
    this.delPointList = [];

    if (this.userRoleID == 4) {
      this.getLineNos();
      // this.initPagingtable();
    }
    if (this.userRoleID == 4 && this.userOperationType === OPERATION_TYPE) {
      // this.opMgrsupplierCodes=this.userDetJson.operationManagerSupplierCode;
      this.initPagingtable();
    }
    if (this.userRoleID == 1) {
      this.initPagingtable();
    }
    this.dropdownSettings2 = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      clearSearchFilter: true,
      searchPlaceholderText: 'Search',
      // enableCheckAll: true,
      // enableSearchFilter: true,
      // limitSelection: 60
    };
    this.dropdownSettings3 = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      allowSearchFilter: true,
      clearSearchFilter: true,
      searchPlaceholderText: 'Search',
      limitSelection: 60
    };
    this.dropdownSettings4 = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      badgeShowLimit: 2,
      enableCheckAll: true,
      enableSearchFilter: true,
      allowSearchFilter: true,
      clearSearchFilter: true,
      searchPlaceholderText: 'Search',
      limitSelection: 60
    };
    // Angular2 multi select settings and config
    this.dropdownSettings = {
      idField:'id',
      textField:'itemName',
      singleSelection: false,
      text: this.translate.instant("Select"),
      selectAllText: this.translate.instant("Select All"),
      unSelectAllText: "UnSelect All",
      classes: "custom-class",
      itemsShowLimit: 2,
      allowSearchFilter: true,
      clearSearchFilter: true,
      searchPlaceholderText: 'Search'
      // enableCheckAll: true,
      // enableSearchFilter: true,
      // limitSelection: 10
    };
  }

  ngAfterViewInit() {
    console.log("viewinit")
    let selectedLineno=""
    let deliveryPoint=[]
    if(localStorage.getItem("partStatusLineNo")){
      selectedLineno = JSON.parse(localStorage.getItem("partStatusLineNo"));
    }
    this.lineNoFilter = selectedLineno;
    if(localStorage.getItem("partStatusDeliveryPoint")){
      deliveryPoint = JSON.parse(
      localStorage.getItem("partStatusDeliveryPoint")
    );
      }
    this.opmDeliveryPointFilter = deliveryPoint;
    this.deliveryPointSelectionArray = deliveryPoint;
    this.initPagingtable();
  }

  initPagingtable() { 
    localStorage.setItem("partStatusSuppCode", JSON.stringify(this.supPoint));
    if(this.lineNoFilter){
      localStorage.setItem("partStatusLineNo", JSON.stringify(this.lineNoFilter));
    }
    
    localStorage.setItem(
      "partStatusDeliveryPoint",
      JSON.stringify(this.opmDeliveryPointFilter)
    );
    this.onChange_newPart(this.newPartconfig, true);
    // To open only new parts accordion and close other accordion
    this.activeIds = ["static-1"];
  }

  onSuppCodeChange(option) {
    if (option == null || option == "") {
      this.disableSuppCodeSearch = true;
    } else {
      this.disableSuppCodeSearch = false;
    }
  }
  onSelectAll(option)
  {
    if (option == null || option == "") {
      this.disableSuppCodeSearch = true;
    } else {
      this.disableSuppCodeSearch = false;
    }
  }
  onDelectAll(option)
  {
    this.disableSuppCodeSearch = true;
  }

  onNextProcessChange(option) {
    this.ovarAllAction = true;
    this.opmDSupplierCodeFilter = [];
    this.opmDeliveryPointFilter = [];
    this.supplierCodeSelectionArray = [];
    this.deliveryPointSelectionArray = [];
    if (option == null || option == "") {
      this.disableNextProcessSearch = true;
    } else {
      this.disableNextProcessSearch = false;
    }
  }

  onOMSupplierCodeChange(option) {
    this.disableNextProcessSearch = true;
    this.lineNoFilter = [];
    if (option != null && option != "")
      this.supplierCodeSelectionArray.push(option);
    if (
      this.deliveryPointSelectionArray &&
      this.deliveryPointSelectionArray.length > 0 &&
      this.supplierCodeSelectionArray.length > 0
    )
      this.ovarAllAction = false;
    else this.ovarAllAction = true;
  }

  onOMSupplierCodeChangeDeselect(option) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.supplierCodeSelectionArray.indexOf(option);
    this.supplierCodeSelectionArray.splice(index, 1);
    if (
      this.deliveryPointSelectionArray &&
      this.deliveryPointSelectionArray.length > 0 &&
      this.supplierCodeSelectionArray.length > 0
    )
      this.ovarAllAction = false;
    else this.ovarAllAction = true;
  }

  onOMDeliveryPointChange(option) {
    if (this.deliveryPointSelectionArray == null)
      this.deliveryPointSelectionArray = [];
    this.disableNextProcessSearch = true;
    this.lineNoFilter = [];
    let deliveryPointselectionArr: any = [];
    if (option != null && option != "")
      this.deliveryPointSelectionArray.push(option);

    if (this.deliveryPointSelectionArray.length > 0) this.ovarAllAction = false;
    else this.ovarAllAction = true;
  }

  onOMDeliveryPointChangeDeselect(option) {
    //this.itemSelectedOperation.pop(item.itemName)
    let index = this.deliveryPointSelectionArray.indexOf(option);
    this.deliveryPointSelectionArray.splice(index, 1);
    if (this.deliveryPointSelectionArray.length > 0) this.ovarAllAction = false;
    else this.ovarAllAction = true;
  }

  open(history, item) {
    this.historyDetails = item;
    this.modalService
      .open(history, { size: "lg", windowClass: "history-modal",backdrop:false })
      .result.then(result => {
        this.historyDetails = item;
      });
  }

  openAppHistory(history, item) {
    this.historyDetails = item;
    this.modalService
      .open(history, { size: "lg", windowClass: "history-modal" ,backdrop:false})
      .result.then(result => {
        this.historyDetails = item;
      });
  }

  appCycleCheck(list) {
    if (list.packageIdStatus == "approved") {
      this.appCycle++;
    } else if (list.packageIdStatus == "rejected") {
      this.appCycle = 0;
    }

    if (this.appCycle == 5) {
      this.appCycle = 0;
      return true;
    }
  }

  openDetail(detailPage) {
    if (this.userRoleID == 4) {
      this.newPart_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
        { title: this.translate.instant("DUEDATE"), name: "dueDate" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];
      this.inProgress_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];

      this.underReview_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];

      this.approved_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];

      this.rejected_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];
    } else {
      this.newPart_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("ASSIGNEDDATE"), name: "assignedDate" },
        { title: this.translate.instant("DUEDATE"), name: "dueDate" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];
      this.inProgress_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];

      this.underReview_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];

      this.approved_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];

      this.rejected_col = [
        { title: this.translate.instant("PARTNO"), name: "partNumber" },
        { title: this.translate.instant("SUPPLIERCODE"), name: "supplierCode" },
        { title: this.translate.instant("PARTNAME"), name: "partName" },
        {
          title: this.translate.instant("DELIVERYPOINT"),
          name: "deliveryPoint"
        },
        { title: "Next Process", name: "lineNumber" },
        { title: this.translate.instant("SUPPLIER"), name: "supplierStatus" },
        { title: this.translate.instant("SM"), name: "supplierManagerStatus" },
        { title: "SM-VS", name: "supplierManagerVSStatus" },
        { title: this.translate.instant("LOGISTICS"), name: "logisticStatus" },
        { title: this.translate.instant("OPERATIONS"), name: "operatorStatus" },
        { title: this.translate.instant("HISTORY"), name: "historyImg" }
      ];
    }

    this.modalRef = this.modalService.open(detailPage, {
      size: "lg",
      windowClass: "detail-modal",backdrop:false
    });
    this.modalRef.result.then(
      () => {
        //When user closes
        // Reset Approved parts details and search string when modal is closed
        this.searchString = "";
        if (this.searchAppParts) {
          this.searchAppParts.length = 0;
        }

        this.newPartconfig.filtering.filterString = "";
        this.inProgressconfig.filtering.filterString = "";
        this.underReviewconfig.filtering.filterString = "";
        this.approvedconfig.filtering.filterString = "";
        this.rejectedconfig.filtering.filterString = "";

        // To reset the table after close of modal popup
        if (detailPage._def.references.newPartsDetails == 2) {
          this.onChange_newPart(this.newPartconfig, true);
        } else if (detailPage._def.references.inProgressDetails == 2) {
          this.onChange_inProgress(this.inProgressconfig, true);
        } else if (detailPage._def.references.underReviewDetails == 2) {
          this.onChange_underReview(this.underReviewconfig, true);
        } else if (detailPage._def.references.approvedNew == 2) {
          this.onChange_approved(this.approvedconfig, true);
        } else if (detailPage._def.references.rejectedDetails == 2) {
          this.onChange_rejected(this.rejectedconfig, true);
        }
      },
      () => {
        //Backdrop click
        // Reset Approved parts details and search string when modal is closed
        this.searchString = "";
        if (this.searchAppParts) {
          this.searchAppParts.length = 0;
        }

        this.newPartconfig.filtering.filterString = "";
        this.inProgressconfig.filtering.filterString = "";
        this.underReviewconfig.filtering.filterString = "";
        this.approvedconfig.filtering.filterString = "";
        this.rejectedconfig.filtering.filterString = "";

        // To reset the table after close of modal popup
        if (detailPage._def.references.newPartsDetails == 2) {
          this.onChange_newPart(this.newPartconfig, true);
        } else if (detailPage._def.references.inProgressDetails == 2) {
          this.onChange_inProgress(this.inProgressconfig, true);
        } else if (detailPage._def.references.underReviewDetails == 2) {
          this.onChange_underReview(this.underReviewconfig, true);
        } else if (detailPage._def.references.approvedNew == 2) {
          this.onChange_approved(this.approvedconfig, true);
        } else if (detailPage._def.references.rejectedDetails == 2) {
          this.onChange_rejected(this.rejectedconfig, true);
        }
      }
    );
  }

  NewPartPkgRoute(item) {
    this.modalRef.close();
    this.router.navigate(["/partDetails/partsInfo/" + item.packageId]);
  }
  

  getLineNos() {
    this.spinner.show();
    let lineNoArr = [];
    // Get line number for Operation user login details
    if (this.lineNumbers !== null && this.lineNumbers !== undefined) {
      this.lineNumbers.forEach(function (value, key) {
        lineNoArr.push({ id: key + 1, itemName: value });
      });
      this.lineNoList = lineNoArr
      console.log("lineno",this.lineNoList)
    }
    this.spinner.hide();
  }

  getOPMSupplierCodes() {
    this.spinner.show();
    let opsuppCodeArr = [];
    // Get line number for Operation user login details
    this.opsupplierCode.forEach(function (value, key) {
      opsuppCodeArr.push({ id: key + 1, itemName: value });
    });
    this.opmSupplierCodeDropdownData = opsuppCodeArr;
    this.spinner.hide();
  }

  getDeliveryPoint() {
    this.spinner.show();
    let deliveryPointArr = [];
    // Get line number for Operation user login details
    this.opDeliveryPoint.forEach(function (value, key) {
      deliveryPointArr.push({ id: key + 1, itemName: value });
    });
    this.opmDeliveryPointDropdownData = deliveryPointArr;

    this.spinner.hide();
  }

  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? start + page.itemsPerPage : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any, col: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = col || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== "" && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === "DESC" ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === "ASC" ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any, tableColumn: any): any {
    let filteredData: Array<any> = data;
    let tblCol = tableColumn;

    tblCol.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(config.filtering.filterString)
      );
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      tableColumn.forEach((column: any) => {
        if (item[column.name]) {
          if (
            item[column.name].toString().match(config.filtering.filterString)
          ) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  public onChange_newPart(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    var selectSuppCode = [],
      userSuppCode,
      lineNos,
      selectLineNos = [],
      selectedOpmSupplierCodes = [];
    var selectedOpmDeliveryPoints = [];
    var selectedDP = [];

    if (config.filtering) {
      Object.assign(this.newPartconfig.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.newPartconfig.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.newPartconfig.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    // Get Line number/next process selected by operation user
    if (this.userRoleID != 4) {
      lineNos = [];
    }
    let OpmdpArray = [];
    OpmdpArray = this.userDetJson.operationManagerdeliveryPointMaster;
    if (
      this.userRoleID == 4 &&
      (!OpmdpArray == null || OpmdpArray.length == 0)
    ) {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }
    if (
      this.userRoleID == 4 &&
      OpmdpArray.length > 0 &&
      this.opmDeliveryPointFilter
    ) {
      this.opmDeliveryPointFilter.forEach(function (value, key) {
        selectedDP.push(value.itemName);
      });
    }

    if (lineNos == null) {
      lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
          console.log(this.supPoint, userSuppCode);
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    //this.opsupplierCode=this.userDetJson.operationManagerSupplierCode;
    //this.opDeliveryPoint=this.userDetJson.operationManagerdeliveryPointMaster;

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (
      this.userRoleID === 4 &&
      this.userOperationType === OPERATION_TYPE
      // this.supplierCodeSelectionArray.length === 0
    ) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    /*this.deliveryPointSelectionArray.forEach(obj=>{
      deliveryPointOMArray.push(obj.itemName);
    });*/

    var dataToSend = {
      lineNumbers: lineNos,
      pageNum: pageNo,
      partStatus: "new",
      roleId: this.userRoleId,
      // searchValue: this.newPartconfig.filtering.filterString,
      searchValue:this.srchValue_new,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      opMgrsupplierCodes: supplierCodesOMArray,
      deliveryPoint: selectedDP
    };

    this.spinner.show();
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.parts = result;
      var partArr;
      var partsData = [];
      var latNewPart;
      var latNewPartData = [];
      console.log(result,"res")
      this.parts.response.content &&
        this.parts.response.content.forEach(function (value, key) {
          partArr = {
            partNumber:
              // '<a class="partno_column stopEve" class="child" (click.stop)="fromChild()" href="#/partDetails/partsInfo/' +
              // value.packageId +
              // '">' +
              // value.partNumber +
              // "</a>",
              value.partNumber,
              packageId:value.packageId,
            supplierCode: value.supplierCode,
            partName: value.partName,
            deliveryPoint: value.deliveryPoint,
            lineNumber: value.lineNumber,
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDate: dateFormatPipeFilter.transform(value.dueDate),
            historyImg:
              '<div class="history_img" (click)="testClose($event)"></div>',
            history: value.historyList,
            partNo: value.partNumber,
            ovarAllPackageIDStatus: value.ovarAllPackageIDStatus
          };

          latNewPart = {
            partNumber: value.partNumber,
            packageId: value.packageId,
            partName: value.partName,
            supplierCode: value.supplierCode,
            deliveryPoint: value.deliveryPoint,
            lineNumber: value.lineNumber,
            assignedDate: dateFormatPipeFilter.transform(value.assignedDate),
            dueDate: dateFormatPipeFilter.transform(value.dueDate),
            history: value.historyList,
            ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
            isActive: value.isActive
          };

          partsData.push(partArr);
          latNewPartData.push(latNewPart);
        });

      this.newPartsData = partsData;
      this.newparts_data=new MatTableDataSource<NewPartsData[]>(this.newPartsData)
      this.latest_NewPart_Data = latNewPartData;
      this.data = partsData;
      this.nplength = this.parts.response.totalElements;

      let filteredData = this.changeFilter(
        this.data,
        this.newPartconfig,
        this.newPart_col
      );
      let sortedData = this.changeSort(
        filteredData,
        this.newPartconfig,
        this.newPart_col
      );
      this.newPart_row =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;

      this.newPart_row = this.rerenderTable(
        this.newPartconfig,
        true,
        this.newPart_col,
        partsData
      );

      this.spinner.hide();
    });
  }

  public onChange_inProgress(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();
    var selectSuppCode = [],
      userSuppCode,
      lineNos,
      selectLineNos = [];

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.inProgressconfig.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.inProgressconfig.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.inProgressconfig.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    // Get Line number/next process selected by operation user
    if (this.userRoleID != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      console.log("test")
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      console.log(this.supPoint)
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (this.deliveryPointSelectionArray) {
      this.deliveryPointSelectionArray.forEach(obj => {
        deliveryPointOMArray.push(obj.itemName);
      });
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    var dataToSend = {
      lineNumbers: lineNos,
      pageNum: pageNo,
      partStatus: "inProgress",
      roleId: this.userRoleId,
      searchValue: this.searchValue_inprogress,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      opMgrsupplierCodes: supplierCodesOMArray,
      deliveryPoint: deliveryPointOMArray
    };

    // if(this.supPoint.length!=0){
    //   this.spinner.show();
    // }
    // else {
    //   this.spinner.hide();
    // }
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.ipResponse = result;
      var partArr;
      var partsData = [];
      var latinProgress;
      var latinProgressData = [];

      this.ipResponse.response.content.forEach(function (value, key) {
        partArr = {
          partNumber:
            // '<a class="partno_column" href="#/partDetails/partsInfo/' +
            // value.packageId +
            // '" (click)="d("")">' +
            // value.partNumber +
            // "</a>",
            value.partNumber,
            packageId:value.packageId,


          supplierCode: value.supplierCode,
          partName: value.partName,
          deliveryPoint: value.deliveryPoint,
          lineNumber: value.lineNumber,
          supplierStatus:
            // '<div class="sup_' + value.supplierStatus + '"></div>',
            value.supplierStatus,
          supplierManagerStatus:
            // '<div class="sm_' + value.supplierManagerStatus + '"></div>',
            value.supplierManagerStatus,

          supplierManagerVSStatus:
            // '<div class="sm_vs_' + value.supplierManagerVSStatus + '"></div>',
            value.supplierManagerVSStatus,
            
          logisticStatus:
            // '<div class="log_' + value.logisticStatus + '"></div>',
            value.logisticStatus,

          operatorStatus:
            // '<div class="opt_' + value.operatorStatus + '"></div>',
            value.logisticStatus,
          ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
          historyImg: '<div class="history_img"></div>',
          history: value.historyList,
          partNo: value.partNumber
        };

        latinProgress = {
          partNumber: value.partNumber,
          packageId: value.packageId,
          supplierCode: value.supplierCode,
          partName: value.partName,
          deliveryPoint: value.deliveryPoint,
          lineNumber: value.lineNumber,
          supplierStatus: value.supplierStatus,
          supplierManagerStatus: value.supplierManagerStatus,
          supplierManagerVSStatus: value.supplierManagerVSStatus,
          logisticStatus: value.logisticStatus,
          operatorStatus: value.operatorStatus,
          ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
          history: value.historyList,
          updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
          isActive: value.isActive
        };

        partsData.push(partArr);
        latinProgressData.push(latinProgress);
      });

      this.inProgress_row = partsData;
      this.inprogress_data=new MatTableDataSource<InprogressData[]>(this.inProgress_row)
      
      this.latest_inProgress_Data = latinProgressData;
      this.iplength = this.ipResponse.response.totalElements;

      let filteredData = this.changeFilter(
        this.latest_inProgress_Data,
        this.inProgressconfig,
        this.inProgress_col
      );
      let sortedData = this.changeSort(
        filteredData,
        this.inProgressconfig,
        this.inProgress_col
      );
      this.inProgress_row =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;

      // Rerender Table
      this.inProgress_row = this.rerenderTable(
        this.inProgressconfig,
        true,
        this.inProgress_col,
        partsData
      );
     
    });
    this.spinner.hide();
  }

  public onChange_underReview(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();

    var supAppCmt,
      smAppCmt,
      smvsAppCmt,
      opAppCmt,
      logAppCmt,
      selectSuppCode = [],
      userSuppCode,
      lineNos,
      selectLineNos = [];

    var sup_string, sm_string, smvs_string, log_string, op_string;

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.underReviewconfig.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.underReviewconfig.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.underReviewconfig.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    // Get Line number/next process selected by operation user
    if (this.userRoleID != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (this.deliveryPointSelectionArray) {
      this.deliveryPointSelectionArray.forEach(obj => {
        deliveryPointOMArray.push(obj.itemName);
      });
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    var dataToSend = {
      lineNumbers: lineNos,
      pageNum: pageNo,
      partStatus: "underReview",
      roleId: this.userRoleId,
      searchValue: this.searchValue_under,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      opMgrsupplierCodes: supplierCodesOMArray,
      deliveryPoint: deliveryPointOMArray
    };

    // if(this.supPoint.length!=0){
    //   this.spinner.show();
    // }
    
      // this.spinner.hide();
    
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.urResponse = result;
      var partArr;
      var partsData = [];
      var latunderReview;
      var latunderReviewData = [];

      this.urResponse.response.content.forEach(function (value, key) {
        value.historyList.forEach(element => {
          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "Supplier"
          ) {
            if (element.comments != null) {
              supAppCmt = element.comments;
            } else {
              supAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "SM_Q"
          ) {
            if (element.comments != null) {
              smAppCmt = element.comments;
            } else {
              smAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "SM_VS"
          ) {
            if (element.comments != null) {
              smvsAppCmt = element.comments;
            } else {
              smvsAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "OP"
          ) {
            if (element.comments != null) {
              opAppCmt = element.comments;
            } else {
              opAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "Logistic"
          ) {
            if (element.comments != null) {
              logAppCmt = element.comments;
            } else {
              logAppCmt = "";
            }
          }
        });

        if (value.supplierStatus == "approved") {
          sup_string =
            "<div class='sup_" +
            value.supplierStatus +
            "'  title='" +
            supAppCmt +
            "' tooltipPosition='top'></div>";
        } else {
          sup_string = "<div class='sup_" + value.supplierStatus + "'></div>";
        }

        if (value.supplierManagerStatus == "approved") {
          sm_string =
            "<div class='sm_" +
            value.supplierManagerStatus +
            "' alt='" +
            smAppCmt +
            "' title='" +
            smAppCmt +
            "' ></div>";
        } else {
          sm_string =
            "<div class='sm_" + value.supplierManagerStatus + "'></div>";
        }

        if (value.supplierManagerVSStatus == "approved") {
          smvs_string =
            "<div class='sm_vs_" +
            value.supplierManagerVSStatus +
            "' alt='" +
            smvsAppCmt +
            "' title='" +
            smvsAppCmt +
            "' ></div>";
        } else {
          smvs_string =
            "<div class='sm_vs_" + value.supplierManagerVSStatus + "'></div>";
        }

        if (value.logisticStatus == "approved") {
          log_string =
            "<div class='log_" +
            value.logisticStatus +
            "' alt='" +
            logAppCmt +
            "' title='" +
            logAppCmt +
            "' ></div>";
        } else {
          log_string = "<div class='log_" + value.logisticStatus + "'></div>";
        }

        if (value.operatorStatus == "approved") {
          op_string =
            "<div class='opt_" +
            value.operatorStatus +
            "' alt='" +
            opAppCmt +
            "' title='" +
            opAppCmt +
            "' ></div>";
        } else {
          op_string = "<div class='opt_" + value.operatorStatus + "'></div>";
        }

        partArr = {
          partNumber:
            // '<a class="partno_column" href="#/partDetails/partsInfo/' +
            // value.packageId +
            // '" (click)="d("")">' +
            // value.partNumber +
            // "</a>",
            value.partNumber,
            packageId:value.packageId,
          supplierCode: value.supplierCode,
          partName: value.partName,
          deliveryPoint: value.deliveryPoint,
          lineNumber: value.lineNumber,
          supplierStatus: sup_string,
          supplierManagerStatus: sm_string,
          supplierManagerVSStatus: smvs_string,
          logisticStatus: log_string,
          operatorStatus: op_string,
          ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
          historyImg: '<div class="history_img"></div>',
          history: value.historyList,
          partNo: value.partNumber
        };

        latunderReview = {
          partNumber: value.partNumber,
          packageId: value.packageId,
          supplierCode: value.supplierCode,
          partName: value.partName,
          deliveryPoint: value.deliveryPoint,
          lineNumber: value.lineNumber,
          supplierStatus: value.supplierStatus,
          supplierManagerStatus: value.supplierManagerStatus,
          supplierManagerVSStatus: value.supplierManagerVSStatus,
          logisticStatus: value.logisticStatus,
          operatorStatus: value.operatorStatus,
          ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
          history: value.historyList,
          updatedDate: dateFormatPipeFilter.transform(value.updatedDate),
          isActive: value.isActive
        };

        partsData.push(partArr);
        latunderReviewData.push(latunderReview);
      });

      this.underReview_row = partsData;
     
      this.latest_underReview_Data = latunderReviewData;
      this.underReview_data=new MatTableDataSource<UnderReviewData[]>( this.latest_underReview_Data)
      this.urlength = this.urResponse.response.totalElements;

      let filteredData = this.changeFilter(
        this.latest_underReview_Data,
        this.underReviewconfig,
        this.underReview_col
      );
      let sortedData = this.changeSort(
        filteredData,
        this.underReviewconfig,
        this.underReview_col
      );
      this.underReview_row =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;

      // Rerender Table
      this.underReview_row = this.rerenderTable(
        this.underReviewconfig,
        true,
        this.underReview_col,
        partsData
      );
      
    });
    this.spinner.hide();
  }

  public onChange_approved(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();

    var supAppCmt,
      smAppCmt,
      smvsAppCmt,
      opAppCmt,
      logAppCmt,
      selectSuppCode = [],
      userSuppCode,
      lineNos,
      selectLineNos = [];

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.approvedconfig.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.approvedconfig.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.approvedconfig.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    // Get Line number/next process selected by operation user
    if (this.userRoleID != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }
    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (this.deliveryPointSelectionArray) {
      this.deliveryPointSelectionArray.forEach(obj => {
        deliveryPointOMArray.push(obj.itemName);
      });
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    var dataToSend = {
      lineNumbers: lineNos,
      pageNum: pageNo,
      partStatus: "approved",
      roleId: this.userRoleId,
      searchValue: this.searchValue_approved,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      opMgrsupplierCodes: supplierCodesOMArray,
      deliveryPoint: deliveryPointOMArray
    };

    // if(this.supPoint.length!=0){
    //   this.spinner.show();
    // }
    // else {
    //   this.spinner.hide();
    // }
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.appResponse = result;
      var partArr;
      var partsData = [];
      var latApproved;
      var latApprovedData = [];

      var sup_string, sm_string, smvs_string, log_string, op_string;

      this.appResponse.response.content.forEach(function (value, key) {
        value.historyList.forEach(element => {
          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "Supplier"
          ) {
            if (element.comments != null) {
              supAppCmt = element.comments;
            } else {
              supAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "SM_Q"
          ) {
            if (element.comments != null) {
              smAppCmt = element.comments;
            } else {
              smAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "SM_VS"
          ) {
            if (element.comments != null) {
              smvsAppCmt = element.comments;
            } else {
              smvsAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "OP"
          ) {
            if (element.comments != null) {
              opAppCmt = element.comments;
            } else {
              opAppCmt = "";
            }
          }

          if (
            element.packageIdStatus == "approved" &&
            element.roleName == "Logistic"
          ) {
            if (element.comments != null) {
              logAppCmt = element.comments;
            } else {
              logAppCmt = "";
            }
          }
        });

        if (value.supplierStatus == "approved") {
          sup_string =
            "<div class='sup_" +
            value.supplierStatus +
            "'  title='" +
            supAppCmt +
            "' tooltipPosition='top'></div>";
        } else {
          sup_string = "<div class='sup_" + value.supplierStatus + "'></div>";
        }

        if (value.supplierManagerStatus == "approved") {
          sm_string =
            "<div class='sm_" +
            value.supplierManagerStatus +
            "' alt='" +
            smAppCmt +
            "' title='" +
            smAppCmt +
            "' ></div>";
        } else {
          sm_string =
            "<div class='sm_" + value.supplierManagerStatus + "'></div>";
        }

        if (value.supplierManagerVSStatus == "approved") {
          smvs_string =
            "<div class='sm_vs_" +
            value.supplierManagerVSStatus +
            "' alt='" +
            smvsAppCmt +
            "' title='" +
            smvsAppCmt +
            "' ></div>";
        } else {
          smvs_string =
            "<div class='sm_vs_" + value.supplierManagerVSStatus + "'></div>";
        }

        if (value.logisticStatus == "approved") {
          log_string =
            "<div class='log_" +
            value.logisticStatus +
            "' alt='" +
            logAppCmt +
            "' title='" +
            logAppCmt +
            "' ></div>";
        } else {
          log_string = "<div class='log_" + value.logisticStatus + "'></div>";
        }

        if (value.operatorStatus == "approved") {
          op_string =
            "<div class='opt_" +
            value.operatorStatus +
            "' alt='" +
            opAppCmt +
            "' title='" +
            opAppCmt +
            "' ></div>";
        } else {
          op_string = "<div class='opt_" + value.operatorStatus + "'></div>";
        }

        partArr = {
          partNumber:
            // '<a class="partno_column" href="#/partDetails/partsInfo/' +
            // value.packageId +
            // '" (click)="d("")">' +
            // value.partNumber +
            // "</a>",
          value.partNumber,
          packageId:value.packageId,
          supplierCode: value.supplierCode,
          partName: value.partName,
          deliveryPoint: value.deliveryPoint,
          lineNumber: value.lineNumber,
          supplierStatus: sup_string,
          supplierManagerStatus: sm_string,
          supplierManagerVSStatus: smvs_string,
          logisticStatus: log_string,
          operatorStatus: op_string,
          ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
          historyImg: '<div class="history_img"></div>',
          history: value.historyList,
          partNo: value.partNumber
        };

        latApproved = {
          partNumber: value.partNumber,
          packageId: value.packageId,
          supplierCode: value.supplierCode,
          partName: value.partName,
          deliveryPoint: value.deliveryPoint,
          lineNumber: value.lineNumber,
          supplierStatus: value.supplierStatus,
          supplierManagerStatus: value.supplierManagerStatus,
          supplierManagerVSStatus: value.supplierManagerVSStatus,
          logisticStatus: value.logisticStatus,
          operatorStatus: value.operatorStatus,
          ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
          history: value.historyList,
          updatedDate: dateFormatPipeFilter.transform(value.updatedDate)
        };

        partsData.push(partArr);
        latApprovedData.push(latApproved);
      });

      this.approved_row = partsData;
     
      this.latest_approved_Data = latApprovedData;
      this.approved_data=new MatTableDataSource<ApprovedData[]>(this.latest_approved_Data)
      this.applength = this.appResponse.response.totalElements;

      let filteredData = this.changeFilter(
        this.latest_approved_Data,
        this.approvedconfig,
        this.approved_col
      );
      let sortedData = this.changeSort(
        filteredData,
        this.approvedconfig,
        this.approved_col
      );
      this.approved_row =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;

      // Rerender Table
      this.approved_row = this.rerenderTable(
        this.approvedconfig,
        true,
        this.approved_col,
        partsData
      );
      
    });
    this.spinner.hide();
  }

  public onChange_rejected(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();
    var supAppCmt,
      supRejCmt,
      smAppCmt,
      smRejCmt,
      smvsAppCmt,
      smvsRejCmt,
      opAppCmt,
      opRejCmt,
      logAppCmt,
      logRejCmt,
      selectSuppCode = [],
      userSuppCode,
      lineNos,
      selectLineNos = [];

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    if (config.filtering) {
      Object.assign(this.rejectedconfig.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.rejectedconfig.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.rejectedconfig.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
        if (sortData.sort == "asc") {
          sortData.sort = "ASC";
        } else if (sortData.sort == "desc") {
          sortData.sort = "DESC";
        }
      }
    });

    // Get Line number/next process selected by operation user
    if (this.userRoleID != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (this.deliveryPointSelectionArray) {
      this.deliveryPointSelectionArray.forEach(obj => {
        deliveryPointOMArray.push(obj.itemName);
      });
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    var dataToSend = {
      lineNumbers: lineNos,
      pageNum: pageNo,
      partStatus: "rejected",
      roleId: this.userRoleId,
      searchValue: this.searchValue_rejected,
      size: this.itemsPerPage,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode,
      opMgrsupplierCodes: supplierCodesOMArray,
      deliveryPoint: deliveryPointOMArray
    };
    // if(this.supPoint.length!=0){
    //   this.spinner.show();
    // }
    // else {
    //   this.spinner.hide();
    // }
    
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.rejResponse = result;
      var partArr;
      var partsData = [];
      var latRejected;
      var latRejectedData = [];

      var sup_string, sm_string, smvs_string, log_string, op_string;

      this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
        this.rejResponse = result;
        
        if (
          this.rejResponse &&
          this.rejResponse.response &&
          Array.isArray(this.rejResponse.response.content)
        ) {
          var partsData = [];
          var latRejectedData = [];
      
          var dateFormatPipeFilter = new dateFormatPipe(); // instantiate here if not already
      
          this.rejResponse.response.content.forEach(value => {
            // Reset comment variables for each item to avoid cross contamination
            let supAppCmt = '';
            let supRejCmt = '';
            let smAppCmt = '';
            let smRejCmt = '';
            let smvsAppCmt = '';
            let smvsRejCmt = '';
            let opAppCmt = '';
            let opRejCmt = '';
            let logAppCmt = '';
            let logRejCmt = '';
      
            if (Array.isArray(value.historyList)) {
              value.historyList.forEach(element => {
                if (element.packageIdStatus === "approved" && element.roleName === "Supplier") {
                  supAppCmt = element.comments;
                }
                if (element.packageIdStatus === "rejected" && element.roleName === "Supplier") {
                  supRejCmt = element.comments;
                }
                if (element.packageIdStatus === "approved" && element.roleName === "SM_Q") {
                  smAppCmt = element.comments;
                }
                if (element.packageIdStatus === "rejected" && element.roleName === "SM_Q") {
                  smRejCmt = element.comments;
                }
                if (element.packageIdStatus === "approved" && element.roleName === "SM_VS") {
                  smvsAppCmt = element.comments;
                }
                if (element.packageIdStatus === "rejected" && element.roleName === "SM_VS") {
                  smvsRejCmt = element.comments;
                }
                if (element.packageIdStatus === "approved" && element.roleName === "OP") {
                  opAppCmt = element.comments;
                }
                if (element.packageIdStatus === "rejected" && element.roleName === "OP") {
                  opRejCmt = element.comments;
                }
                if (element.packageIdStatus === "approved" && element.roleName === "Logistic") {
                  logAppCmt = element.comments;
                }
                if (element.packageIdStatus === "rejected" && element.roleName === "Logistic") {
                  logRejCmt = element.comments;
                }
              });
            }
      
            // Prepare status strings with comments for tooltips
            let sup_string = "";
            if (value.supplierStatus === "rejected") {
              sup_string = `<div class='sup_${value.supplierStatus}' title='${supRejCmt}' tooltipPosition='top'></div>`;
            } else if (value.supplierStatus === "approved") {
              sup_string = `<div class='sup_${value.supplierStatus}' title='${supAppCmt}' tooltipPosition='top'></div>`;
            } else {
              sup_string = `<div class='sup_${value.supplierStatus}'></div>`;
            }
      
            let sm_string = "";
            if (value.supplierManagerStatus === "rejected") {
              sm_string = `<div class='sm_${value.supplierManagerStatus}' alt='${smRejCmt}' title='${smRejCmt}'></div>`;
            } else if (value.supplierManagerStatus === "approved") {
              sm_string = `<div class='sm_${value.supplierManagerStatus}' alt='${smAppCmt}' title='${smAppCmt}'></div>`;
            } else {
              sm_string = `<div class='sm_${value.supplierManagerStatus}'></div>`;
            }
      
            let smvs_string = "";
            if (value.supplierManagerVSStatus === "rejected") {
              smvs_string = `<div class='sm_vs_${value.supplierManagerVSStatus}' alt='${smvsRejCmt}' title='${smvsRejCmt}'></div>`;
            } else if (value.supplierManagerVSStatus === "approved") {
              smvs_string = `<div class='sm_vs_${value.supplierManagerVSStatus}' alt='${smvsAppCmt}' title='${smvsAppCmt}'></div>`;
            } else {
              smvs_string = `<div class='sm_vs_${value.supplierManagerVSStatus}'></div>`;
            }
      
            let log_string = "";
            if (value.logisticStatus === "rejected") {
              log_string = `<div class='log_${value.logisticStatus}' alt='${logRejCmt}' title='${logRejCmt}'></div>`;
            } else if (value.logisticStatus === "approved") {
              log_string = `<div class='log_${value.logisticStatus}' alt='${logAppCmt}' title='${logAppCmt}'></div>`;
            } else {
              log_string = `<div class='log_${value.logisticStatus}'></div>`;
            }
      
            let op_string = "";
            if (value.operatorStatus === "rejected") {
              op_string = `<div class='opt_${value.operatorStatus}' alt='${opRejCmt}' title='${opRejCmt}'></div>`;
            } else if (value.operatorStatus === "approved") {
              op_string = `<div class='opt_${value.operatorStatus}' alt='${opAppCmt}' title='${opAppCmt}'></div>`;
            } else {
              op_string = `<div class='opt_${value.operatorStatus}'></div>`;
            }
      
            // Construct partArr object
            const partArr = {
              partNumber: value.partNumber,
              packageId: value.packageId,
              supplierCode: value.supplierCode,
              partName: value.partName,
              deliveryPoint: value.deliveryPoint,
              lineNumber: value.lineNumber,
              supplierStatus: sup_string,
              supplierManagerStatus: sm_string,
              supplierManagerVSStatus: smvs_string,
              logisticStatus: log_string,
              operatorStatus: op_string,
              ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
              historyImg: '<div class="history_img"></div>',
              history: value.historyList,
              partNo: value.partNumber
            };
      
            // Construct latRejected object
            const latRejected = {
              partNumber: value.partNumber,
              packageId: value.packageId,
              supplierCode: value.supplierCode,
              partName: value.partName,
              deliveryPoint: value.deliveryPoint,
              lineNumber: value.lineNumber,
              supplierStatus: value.supplierStatus,
              supplierManagerStatus: value.supplierManagerStatus,
              supplierManagerVSStatus: value.supplierManagerVSStatus,
              logisticStatus: value.logisticStatus,
              operatorStatus: value.operatorStatus,
              ovarAllPackageIDStatus: value.ovarAllPackageIDStatus,
              history: value.historyList,
              rejectedComments: value.rejectedComments,
              updatedDate: dateFormatPipeFilter.transform(value.updatedDate)
            };
      
            partsData.push(partArr);
            latRejectedData.push(latRejected);
          });
      
          // Assign or use partsData and latRejectedData as needed
          this.rejected_row = partsData;
          this.rejected_data = new MatTableDataSource(partsData);
          this.latest_rejected_Data = latRejectedData;
      
          // Continue with your filtering, sorting, pagination logic here...
      
        } else {
          console.warn('Rejected API response missing content or invalid', this.rejResponse);
          // Optionally, clear data or show no results UI here
          this.rejected_row = [];
          this.rejected_data = new MatTableDataSource([]);
          this.latest_rejected_Data = [];
        }
      
        this.spinner.hide();
      }, error => {
        console.error('Rejected API call failed:', error);
        this.spinner.hide();
      });
      
      this.rejected_row = partsData;
    
      this.latest_rejected_Data = latRejectedData;
      this.rejected_data=new MatTableDataSource<RejectedData[]>(this.latest_rejected_Data)
      this.rejlength = this.rejResponse.response.totalElements;

      let filteredData = this.changeFilter(
        this.latest_rejected_Data,
        this.rejectedconfig,
        this.rejected_col
      );
      let sortedData = this.changeSort(
        filteredData,
        this.rejectedconfig,
        this.rejected_col
      );
      this.rejected_row =
        page && config.paging ? this.changePage(page, sortedData) : sortedData;

      // Rerender Table
      this.rejected_row = this.rerenderTable(
        this.rejectedconfig,
        true,
        this.rejected_col,
        partsData
      );
      this.spinner.hide();
    });
  }

  public rerenderTable(
    config: any,
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage },
    tableColumn: any,
    tableData: any
  ): any {
    var renderConfig: any = {
      paging: true,
      sorting: { columns: tableColumn },
      filtering: { filterString: "" },
      className: ["table-striped", "table-bordered"]
    };

    if (config.filtering) {
      Object.assign(renderConfig.filtering, config.filtering);
    }
    if (config.sorting) {
      Object.assign(renderConfig.sorting, config.sorting);
    }
    let filteredData = this.changeFilter(tableData, renderConfig, tableColumn);
    let sortedData = this.changeSort(filteredData, renderConfig, tableColumn);
    return page && config.paging
      ? this.changePage(page, sortedData)
      : sortedData;
  }

  public onRowClick(history, data: any): any {
   console.log("event",data)
    
    if (data.column == "partNumber") {
      this.modalRef.close();
    }
     if (data.column == "historyImg") 
     {
      this.open(history, data.row);
      
    }
  }

  public rowClicked(history,data:any,event:any):any
  {
    if (data == "partNumber") {
      this.modalRef.close();
    }
    if (data== "historyImg") 
    {
     this.open(history, event);
     
    }
  }

  public onRowUndereviewClick(history, underReview, data: any): any {
    if (data.column == "partNumber") {
      this.modalRef.close();
    }
    if (data.column == "historyImg") {
      this.open(history, data.row);
    }
    if (data.column == "supplierManagerStatus") {
      this.uderReviewDetails(underReview, data.row, "SM_Q", 2);
    }
    if (data.column == "supplierManagerVSStatus") {
      this.uderReviewDetails(underReview, data.row, "SM-VS", 7);
    }
    if (data.column == "operatorStatus") {
      this.uderReviewDetails(underReview, data.row, "Operations", 4);
    }
    if (data.column == "logisticStatus") {
      this.uderReviewDetails(underReview, data.row, "Logistics", 3);
    }
  }

  showAppRej(item, role, status) {
    var itemByRoleStatus;

    if (status == "supplierStatus") {
      itemByRoleStatus = item.supplierStatus;
    } else if (status == "supplierManagerStatus") {
      itemByRoleStatus = item.supplierManagerStatus;
    } else if (status == "supplierManagerVSStatus") {
      itemByRoleStatus = item.supplierManagerVSStatus;
    } else if (status == "operatorStatus") {
      itemByRoleStatus = item.operatorStatus;
    } else if (status == "logisticStatus") {
      itemByRoleStatus = item.logisticStatus;
    }

    if (itemByRoleStatus == "approved" || itemByRoleStatus == "rejected") {
      return true;
    } else {
      return false;
    }
  }

  showRejected(item, role, status) {
    var itemByRoleStatus;

    if (status == "supplierStatus") {
      itemByRoleStatus = item.supplierStatus;
    } else if (status == "supplierManagerStatus") {
      itemByRoleStatus = item.supplierManagerStatus;
    } else if (status == "supplierManagerVSStatus") {
      itemByRoleStatus = item.supplierManagerVSStatus;
    } else if (status == "operatorStatus") {
      itemByRoleStatus = item.operatorStatus;
    } else if (status == "logisticStatus") {
      itemByRoleStatus = item.logisticStatus;
    }
    if (itemByRoleStatus == "rejected") {
      return true;
    } else {
      return false;
    }
  }

  getComments(item, role) {
    var cmts;
    item.history.forEach(element => {
      if (element.packageIdStatus == "approved") {
        if (element.roleName === role) {
          cmts = element.comments;
        }
      } else if (element.packageIdStatus == "rejected") {
        if (element.roleName === role) {
          cmts = element.comments;
        }
      }
    });

    return cmts;
  }

  getAppParts(config :any,  
    page: any = { page: this.page, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

 if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = page.page - 1;
    }

    var appParts,
      userSuppCode,
      selectSuppCode = [],
      lineNos,
      selectLineNos = [];

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }

    // Get Line number/next process selected by operation user
    if (this.userRoleID != 4) {
      lineNos = [];
    } else {
      if (this.lineNoFilter) {
        this.lineNoFilter.forEach(function (value, key) {
          selectLineNos.push(value.itemName);
        });

        if (selectLineNos.length > 0) {
          lineNos = selectLineNos;
        }
      }
    }

    if (lineNos == null) {
      lineNos = [];
    }

    var supplierCodesOMArray = [];
    var deliveryPointOMArray = [];

    this.supplierCodeSelectionArray.forEach(obj => {
      supplierCodesOMArray.push(obj.itemName);
    });
    if (this.deliveryPointSelectionArray) {
      this.deliveryPointSelectionArray.forEach(obj => {
        deliveryPointOMArray.push(obj.itemName);
      });
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = [];
    }

    var dataToSend = {
      lineNumbers: lineNos,
      pageNum: pageNo,
      partStatus: "approved",
      roleId: this.userRoleId,
      searchValue: this.searchValue_approved,
      size: this.itemsPerPage,
      sortColumn: "",
      sortType: "",
      supplierCodes: userSuppCode,
      opMgrsupplierCodes: supplierCodesOMArray,
      deliveryPoint: deliveryPointOMArray
    };

    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      appParts = result;
      this.searchAppParts = appParts.response.content;
      this.applength = appParts.response.totalElements;
      this.spinner.hide();
    });
  }

  uderReviewDetails(history, item, type, roleid) {
    let supplierCode;
    if (roleid == 4) {
      supplierCode = item.lineNumber;
    } else {
      supplierCode = item.supplierCode;
    }
    this.userDetialsTableTitle = type;
    if (
      item.supplierManagerVSStatus == "underReview" ||
      item.supplierManagerVSStatus == "<div class='sm_vs_underReview'></div>"
    ) {
      this.logbaseService
        .userEmailDetails(supplierCode, roleid)
        .subscribe(res => {
          let data = res;
          this.UserUnderReviewDetails = data;
          this.modalService
            .open(history, {
              size: "lg",
              windowClass: "underReviewStatus-modal",backdrop:false
            })
            .result.then(result => { });
        });
    }
  }

  public exportTable(
    config: any = this.underReviewconfig,
    page: any = { page: 0, itemsPerPage: this.itemsPerPage }
  ): any {
    this.spinner.show();
    var pageNo;
    var sortData = {
      name: "",
      sort: ""
    };

    var dateFormatPipeFilter = new dateFormatPipe();
    var supAppCmt, smAppCmt, smvsAppCmt, opAppCmt, logAppCmt;
    var sup_string, sm_string, smvs_string, log_string, op_string;
    var selectSuppCode = [],
      userSuppCode;
    if (page) {
    }

    if (page.page == undefined || page.page == null) {
      pageNo = 0;
    } else {
      if (page.page != 0) {
        pageNo = page.page - 1;
      }
    }

    if (config.filtering) {
      Object.assign(this.underReviewconfig.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.underReviewconfig.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.underReviewconfig.sorting.columns.forEach(function (value, key) {
      if (value.sort) {
        sortData = {
          name: value.name,
          sort: value.sort
        };
      } else if (sortData.sort == "asc") {
        sortData.sort = "ASC";
      } else if (sortData.sort == "desc") {
        sortData.sort = "DESC";
      }
    });
    if (this.userRoleId == 4) {
      console.log(this.userDetJson);
    }
    if (this.filterlineNos.length > 0) {
      this.lineNos = this.filterlineNos;
    } else {
      this.lineNos = [];
    }

    if (this.lineNos == null) {
      this.lineNos = [];
    }

    //Get Selected Supplier Code
    if (this.userRoleID == 1) {
      userSuppCode = this.userDetJson.supplierCode;
    } else {
      if (this.supPoint) {
        this.supPoint.forEach(function (value, key) {
          selectSuppCode.push(value.itemName);
        });

        if (selectSuppCode.length > 0) {
          userSuppCode = selectSuppCode;
        }
      }
    }

    if (userSuppCode == null) {
      userSuppCode = [];
    }
    // To enable export feature
    // if (this.filterSuppCode) {
    //   if ((this.filterSuppCode.length > 0 && this.filterSuppCode.length <= 10) || (this.locCodeTbl.length > 0 && this.locCodeTbl.length <= 10)) {
    //     this.enableExport = true;
    //   } else {
    //     this.enableExport = false;
    //   }
    // }

    // To enable export feature
    if (this.filterlineNos) {
      if (this.filterlineNos.length > 0 && this.filterlineNos.length <= 10) {
        this.enableExport = true;
      } else {
        this.enableExport = false;
      }
    }

    if (this.userRoleID === 4 && this.userOperationType === OPERATION_TYPE) {
      // supplierCodesOMArray = this.userDetJson.operationManagerSupplierCode;
      userSuppCode = this.userDetJson.operationManagerSupplierCode;
    }

    let dataToSend = {
      lineNumbers: this.lineNos,
      pageNum: 0,
      partStatus: "underReview",
      roleId: this.userRoleId,
      searchValue: this.underReviewconfig.filtering.filterString,
      size: this.urResponse.response.totalElements,
      sortColumn: sortData.name,
      sortType: sortData.sort,
      supplierCodes: userSuppCode
    };

    this.spinner.show();
    this.logbaseService.partStatusWtPaging(dataToSend).subscribe(result => {
      this.urResponse = result;

      // this.downloadData = viewData;
      let exportdata = [];
      this.urResponse.response.content.forEach(element => {
        let viewData: any = {};
        (viewData.partNumber = element.partNumber),
          (viewData.supplierCode = element.supplierCode),
          (viewData.partName = element.partName),
          (viewData.deliveryPoint = element.deliveryPoint),
          (viewData.lineNumber = element.lineNumber),
          (viewData.supplierStatus = element.supplierStatus),
          (viewData.supplierManagerStatus = element.supplierManagerStatus);
        (viewData.supplierManagerVSStatus = element.supplierManagerVSStatus),
          (viewData.logisticStatus = element.logisticStatus),
          (viewData.operatorStatus = element.operatorStatus);
        exportdata.push(viewData);
      });
      // this.exportlength = this.urResponse.response.totalElements;
      // let filteredData = this.changeFilter(
      //   this.latest_underReview_Data,
      //   this.underReviewconfig,
      //   this.underReview_col
      // );
      // let sortedData = this.changeSort(filteredData, this.underReviewconfig, this.underReview_col);
      // this.underReview_row = page && config.paging ? this.changePage(page, sortedData) : sortedData;
      this.spinner.hide();
      //     this.exportCSV(this.fcdailyView);
      var options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalseparator: ".",
        showLabels: true,
        // showTitle: true,
        title: "Under Review Status data",
        headers: [
          "Part Number",
          "Supplier Code",
          "Part Name",
          "Delivery Point",
          "Next Process",
          "Supplier Status",
          "SM-Q Status",
          "SM-VS Status",
          "Logistics Status",
          "Operations Status"
        ],
        removeNewLines: true
      };

      new AngularCsv(exportdata, "Under Review Data", options);
    });
  }

  // Function to call API when accordion is opened based on accordion ID
  public beforeChange(panelid:any) {
    
    var index=Number(panelid.slice(-1))
    

    if (index % 0 == 0 || index%5==0 ) {
      this.onChange_newPart(this.inProgressconfig, true);
    }

    if (index % 1 == 0 || index%6==0 ) {
      this.onChange_inProgress(this.inProgressconfig, true);
    }

    if (index % 2 == 0 || index%7==0  ) {
      this.onChange_underReview(this.underReviewconfig, true);
    }

    if (index % 3 == 0 || index%8==0  ) {
      //this.onChange_approved(this.approvedconfig, true);
    }

    if (index % 4 == 0 || index%9==0 ) {
      this.onChange_rejected(this.rejectedconfig, true);
    }
    
  }
  // public beforeChange2(){
  //   this.onChange_inProgress(this.inProgressconfig, true);
  // }
}
